import { render } from "./TableConfiguration.vue?vue&type=template&id=b79fe64a"
import script from "./TableConfiguration.vue?vue&type=script&lang=js"
export * from "./TableConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__